import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

const DeleteConfirmDialog = ({ open, onClose, onConfirm, product }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: 600 }}>Potwierdź usunięcie</DialogTitle>
      <DialogContent>
        <Typography>
          Czy na pewno chcesz usunąć produkt "{product?.name}"?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Anuluj
        </Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Usuń
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog; 